//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  transition: 'smooth',
  data: () => ({
    loading: false,
    form: {
      name: '',
      mail: '',
      date: new Date(),
      time: '12:30',
      message: '',
      hasAgreedToPrivacyStatement: false,
    },
  }),

  mounted() {
    const { serviceTime, serviceName } = this.$route.query
    if (serviceTime && serviceName) {
      this.form.message = `Hallo Tino,
ich möchte gerne bei Ihnen einen Termin für ${serviceTime} Minuten ${serviceName} reservieren.`
    }
  },

  methods: {
    async onSubmit() {
      try {
        const { hasAgreedToPrivacyStatement } = this.form
        if (!hasAgreedToPrivacyStatement) {
          this.$bus.$emit('alert', {
            message: 'Bitte stimmen Sie den Datenschutzbedingungen zu',
            variant: 'warning',
          })
          return
        }

        this.loading = true
        this.$nuxt.$loading.start()
        const response = await this.$axios.$post('sendmail', { ...this.form })

        this.$bus.$emit('alert', {
          message: response?.msg,
          variant: 'info',
        })
        this.$router.push({ path: '/' })
      } catch ({ response }) {
        this.$bus.$emit('alert', {
          message:
            'Ihre Email konnte leider nicht gesendet werden. Fehlercode ' +
            response?.status,
          variant: 'danger',
        })
      } finally {
        this.loading = false
        this.$nuxt.$loading.finish()
      }
    },
  },
}
